module.exports = __webpack_public_path__ + "img/pr-5.ba2c174a.png";